module.exports = __webpack_public_path__ + "static/media/Book_Vaccine_Slot.4ae344d1.svg";